export interface StatusMessage {
  title: string;
  message: string;
  statusType: StatusType;
}

export enum StatusType {
  DOWNTIME,
  INSTABILITY,
}
